var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-41.1%",
    y: "-172.5%",
    width: "182.1%",
    height: "445.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 12,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.05 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDDA5--\\u0421\\u041A--|---Web-UI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "05-03-\\u0421\\u041A-|-\\u0438\\u0441\\u0442\\u043E\\u0440\\u0438\\u044F",
    transform: "translate(-32.000000, -140.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1440,
    height: 900
  }), /*#__PURE__*/React.createElement("g", {
    id: "Left-navigation"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "left-navigation",
    x: 0,
    y: 0,
    width: 208,
    height: 900
  }), /*#__PURE__*/React.createElement("g", {
    id: "buttons/medium/default",
    transform: "translate(20.000000, 130.000000)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "button",
    x: 0,
    y: 0,
    width: 168,
    height: 40,
    rx: 12
  }), /*#__PURE__*/React.createElement("g", {
    id: "icons/arrow/dropdown",
    transform: "translate(12.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "box",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0335798,6 C13.1402236,6 13.2424512,6.04258979 13.31755,6.11830689 L13.31755,6.11830689 L13.8774911,6.68624718 C13.9532082,6.76134592 13.995798,6.86357352 13.995798,6.97021732 C13.995798,7.07686113 13.9532082,7.17908872 13.8774911,7.25418747 L13.8774911,7.25418747 L11.196,9.94 L13.9482016,12.6917662 C14.0049895,12.7480903 14.0431432,12.8196743 14.0586708,12.8969364 L14.0665085,12.9757364 C14.0665085,13.0823802 14.0239187,13.1846078 13.9482016,13.2597065 L13.9482016,13.2597065 L13.3802613,13.8276468 C13.3065382,13.9028901 13.2056315,13.9452916 13.1002908,13.9452916 C12.9949501,13.9452916 12.8940433,13.9028901 12.8203202,13.8276468 L12.8203202,13.8276468 L10.0686095,11.0759361 L7.31689883,13.835646 C7.24180008,13.9113631 7.13957248,13.9539529 7.03292868,13.9539529 C6.92628488,13.9539529 6.82405728,13.9113631 6.74895854,13.835646 L6.74895854,13.835646 L6.18901741,13.2677057 C6.11330031,13.1926069 6.07071052,13.0903793 6.07071052,12.9837355 C6.07071052,12.8770917 6.11330031,12.7748641 6.18901741,12.6997654 L6.18901741,12.6997654 L8.869,10.013 L6.11830689,7.26218663 C6.06151907,7.20586257 6.02336535,7.13427853 6.00783773,7.05701641 L6,6.97821648 C6,6.87157268 6.04258979,6.76934508 6.11830689,6.69424634 L6.11830689,6.69424634 L6.68624718,6.12630605 C6.7599703,6.05106271 6.86087706,6.00866127 6.96621774,6.00866127 C7.07155842,6.00866127 7.17246519,6.05106271 7.24618831,6.12630605 L7.24618831,6.12630605 L9.997899,8.87801674 L12.7496097,6.11830689 C12.8247084,6.04258979 12.926936,6 13.0335798,6 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF",
    transform: "translate(10.033254, 9.976976) rotate(-315.000000) translate(-10.033254, -9.976976) "
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus-icon.310cff57.svg";
export { ForwardRef as ReactComponent };